import React from 'react';
import { CtaButton } from './CtaButton';
export function UrgencySection() {
  return <section className="w-full bg-ink-900 py-14" aria-labelledby="urgency-title" style={{
    paddingBottom: "0px"
  }} data-id="element-167" data-mp="2sit1phcgikic">
      <div className="mx-auto max-w-2xl px-5" data-id="element-168" data-mp="36a7j5jqpudna">
        <div className="rounded-2xl border border-danger/40 bg-danger/5 p-7 text-center sm:p-10" data-id="element-169" data-mp="36c2613ljsfu0">
          <h2 id="urgency-title" className="font-display text-2xl font-bold text-danger sm:text-3xl" data-id="element-170" data-mp="31h4o176aiw4z">
            ⏰ Launch Price Closing Soon
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-body" data-id="element-171" data-mp="3b7zbufz6q3sj">
            ⚠️ After this window closes, the price increases permanently.
          </p>

          <div className="mx-auto mt-6 max-w-md" data-id="element-172" data-mp="3l78edx848qqi">
            <div className="h-2.5 w-full overflow-hidden rounded-full bg-white/10" role="img" aria-label="74% of launch spots already claimed" data-id="element-173" data-mp="3l8jijy5h40i5">
              <div className="h-full w-[74%] rounded-full bg-danger" data-id="element-174" data-mp="1uwludzorqe2a" />
            </div>
            <p className="mt-3 text-sm font-bold text-danger" data-id="element-175" data-mp="1qva740tda4x9">
              🔴 74% of launch spots already claimed
            </p>
          </div>

          <div className="mt-8 flex justify-center" data-id="element-176" data-mp="2xrzlqattdpzu">
            <CtaButton data-id="element-177" data-mp="2xqeouek11uyt" />
          </div>
        </div>
      </div>
    </section>;
}